// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentMethodSepaDebitResponse

export type BillingPaymentMethodSepaDebitApiResponse = {
	last4: string;
};

export type BillingPaymentMethodSepaDebit = {
	last4: string;
};

export function hydrateBillingPaymentMethodSepaDebit(data: BillingPaymentMethodSepaDebitApiResponse): BillingPaymentMethodSepaDebit {
	return { ...data };
}